// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c962d88f","453":"c780bbce","455":"cbbea76f","977":"d27e7aec"}[chunkId] + ".chunk.js";
};